import { useNavigate, useParams, Navigate } from "react-router-dom"; // For navigation
import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const GameLoader = () => {
  const navigate = useNavigate();
  let { id } = useParams();
  const goHome = () => {
    navigate("/"); // Navigate to the home page
  };

  const [redirect, setRedirect] = useState(false);
  const [msisdn, setMsisdn] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [accessToken, setAccessToken] = useState("");
  const [scienAccessToken, setScienAccessToken] = useState("");
  const [cgUrl, setCgUrl] = useState("");
  const [cgRedirect, setCgRedirect] = useState(false);
  const [sourceIP, setSourceIP] = useState("");
  const [redirectRequestId, setRedirectRequestId] = useState(null);
  const [redirectMessage, setRedirectMessage] = useState("");
  const [activeSub, setActiveSub] = useState("NotActive");
  const [mFilterId, setMFilterId] = useState("");
  const [message, setMessage] = useState("");
  // eslint-disable-next-line no-undef
  const [ip, setIp] = useState("");
  const userAgent = navigator.userAgent; // Get User-Agent
  const redirectRequestedRef = React.useRef(false);

  useEffect(() => {
    // Case 1: params AFTER hash
    // #/gameLoader/tile-master?requestid=xxx
    const hash = window.location.hash;
    let queryString = "";

    if (hash.includes("?")) {
      queryString = hash.split("?")[1];
    } else {
      // Case 2: params BEFORE hash
      // ?requestid=xxx#/gameLoader/tile-master
      queryString = window.location.search.substring(1);
    }

    const queryParams = new URLSearchParams(queryString);

    const requestid = queryParams.get("requestid") || "";
    const message = queryParams.get("message") || "";
    const mFilterId = queryParams.get("mfilter_id") || "";
    const msisdn = queryParams.get("msisdn") || "";
    const error = queryParams.get("error") || "";

    setRedirectRequestId(requestid);
    setRedirectMessage(message);
    setMsisdn(msisdn);
    setError(error);
    setMFilterId(mFilterId);
    setMessage(message);
  }, []);

  useEffect(() => {
    if (!redirectRequestId) return;

    const postMFilterOnce = async () => {
      try {
        await axios.post("mFilterResponse", {
          msisdn,
          request_id: redirectRequestId,
          mFilterID: mFilterId,
          error,
          message,
        });
      } catch (err) {
        console.error("mFilterResponse failed", err);
      }
    };

    postMFilterOnce();
  }, [redirectRequestId]);

  const postMsisdnToBackend = async (msisdn, gameId) => {
    try {
      const { data } = await axios.post("gameAccessData", {
        msisdn,
        game_id: gameId,
      });

      setActiveSub(data.status);
      return data.status;
    } catch (err) {
      console.error("postMsisdnToBackend failed", err);
      return null;
    }
  };

  const getRedirectUrl = async ({
    token,
    msisdn,
    ipAddress,
    gameId,
    userAgent,
  }) => {
    if (redirectRequestedRef.current) return null;
    redirectRequestedRef.current = true;

    const { data } = await axios.post(
      "scienRedirect",
      {
        msisdn,
        campaign_id: "67e0e22949ffff7516d3f969",
        source_ip: ipAddress,
        requestid: generateRandomString(10),
        redirect_url: `https://fun.stargames.co.ke/#/gameLoader/${gameId}`,
        user_agent: userAgent,
        access_token: token,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );

    if (data.cg_url) {
      setCgUrl(data.cg_url);
      setCgRedirect(true);
    }

    return data.cg_url;
  };

  const fetchMaskedMsisdn = async (accessToken) => {
    const response = await axios.get(
      "https://identity.safaricom.com/partner/api/v2/fetchMaskedMsisdn",
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "X-App": "he-partner",
          "X-MessageID": "1234",
          "X-Source-System": "he-partner",
        },
        withCredentials: false, //
      },
    );

    const service = response.data.ServiceResponse;
    if (service.ResponseHeader.ResponseCode !== "200") {
      throw new Error(service.ResponseHeader.ResponseMsg || "safaricom error");
    }

    return service.ResponseBody.Response.Msisdn;
  };

  useEffect(() => {
    if (redirectRequestId !== "") return;

    let cancelled = false;

    const runFlow = async () => {
      try {
        setLoading(true);

        // 1️⃣ Get HE access token
        const { data: tokenData } = await axios.get("safaricomHeAccessToken/1");
        if (cancelled) return;

        setAccessToken(tokenData.access_token);
        setSourceIP(tokenData.source_ip);

        // 2️⃣ Fetch masked MSISDN
        const msisdn = await fetchMaskedMsisdn(tokenData.access_token);
        if (cancelled) return;

        setMsisdn(msisdn);

        // 3️⃣ Post MSISDN to backend
        const status = await postMsisdnToBackend(msisdn, id);
        if (cancelled) return;

        // 🛑 ACTIVE users stop here
        if (status === "Active") {
          console.log("Subscriber active — stopping flow");
          return;
        }

        // 4️⃣ Get SCIEN token
        const scienToken = await getNewAccessToken();
        if (!scienToken || cancelled) return;

        // 5️⃣ Redirect
        await getRedirectUrl({
          token: scienToken,
          msisdn,
          ipAddress: tokenData.source_ip,
          gameId: id,
          userAgent,
        });
      } catch (err) {
        console.error(err);

        if (err.response?.status === 403) {
          toast.error("Access Denied ❌");
          setRedirect(true);
        } else if (err.message?.includes("CORS")) {
          toast.error("Access Denied ❌ (CORS Error)");
        } else {
          setError("Failed to fetch data. Please try again.");
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    runFlow();

    return () => {
      cancelled = true;
    };
  }, [id, userAgent, redirectRequestId]);

  useEffect(() => {
    // Fetch the current IP address
    fetch("https://api64.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => setIp(data.ip))
      .catch((error) => console.error("Error fetching IP:", error));
  }, []);

  useEffect(() => {
    if (cgRedirect && cgUrl && redirectRequestId === "") {
      console.log("Redirecting to:", cgUrl);
      window.location.assign(cgUrl);
    }
  }, [cgRedirect, cgUrl, redirectRequestId]);

  const generateRandomString = (length = 10) => {
    const characters =
      "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz123456789"; // Excludes 0 and O
    let result = "";
    const randomValues = new Uint8Array(length);
    window.crypto.getRandomValues(randomValues);

    for (let i = 0; i < length; i++) {
      result += characters[randomValues[i] % characters.length];
    }

    return result;
  };

  const getNewAccessToken = async () => {
    console.log("Fetching new access token...");
    const { data } = await axios.get(`scienLabsAccessToken/1`);
    setScienAccessToken(data.access_token);
    //alert("Scien Access: " + data.token)
    return data.access_token;
  };

  if (redirect) {
    return <Navigate to={"/noSafData"} />;
  }

  // if(cgRedirect){
  //   console.log("Redirect to CG URL:", cgUrl);
  //   window.location.href=cgUrl;
  // }else{
  //   console.log("No CG URL available");
  // }

  return (
    <>
      {/* <div className="p-4">
      {loading && <p className="text-blue-500">Loading...</p>}
      {error && <p className="text-red-500">{error}</p>}
      {msisdn && <p className="text-green-500">Masked MSISDN: {msisdn}</p>}
    </div> */}
      <div className="relative bg-gray-900 h-screen w-screen">
        {/* Floating Home Button */}
        <button
          onClick={goHome}
          className="absolute top-4 right-4 flex items-center space-x-2 bg-gray-800 text-gray-300 p-2 rounded-lg shadow hover:text-white hover:bg-gray-700"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M3 12l9-9m0 0l9 9m-9-9v18"
            />
          </svg>
          <span className="hidden md:inline text-sm font-medium">Home</span>
        </button>

        {/* Fullscreen Iframe */}
        <iframe
          src={`/games/${id}/index.html`}
          //src={`https://aviator-game-by5.pages.dev/?data=X2nUZlhXwPO+28WWifdhktarc5UAwIHxpiSeqHmevZAnp0CpUg+WG0gWCbqpIwwXfILU8c4Phh0xVhuWVxF7LgSoiBs4hBwBVqYLcIALtia+VDomemrVAI5h5y6BDHMeOrv/DluhkUpmxIP62ClpS8gyqb/US8oddzFbwcmsQgStLS4moCgC1enIiI2o1L1DYQwKDpBiio9zZAD0thxaXEuBKf4hUjA5LCSHtX5iH+7FkxSj1+7I/PcoOrtHLtcdY10XziUIdmEKlelYnyxVhiGr4T35oWQ90WRenuG6BhAWJEa8CwTOYYeNTUE1CHiaUsm2TOumc6a5ls`}
          sandbox="allow-scripts allow-same-origin"
          title="Game"
          className="w-full h-full"
        />
      </div>
    </>
  );
};
export default GameLoader;
